// config.js
// Default `/api`: browser hits same origin; CRA dev proxy (package.json) forwards to localhost:8084; Docker nginx proxies to the backend.
export const baseUrl = process.env.REACT_APP_BACKEND_URL || "/api";